import getRoutes from '../routes';
import ModuleService from '../services/module.service';

const customLinksModules = [ModuleService.TYPE_LINK, ModuleService.TYPE_YOUTUBE, ModuleService.TYPE_VIMEO];

const createNavLinks = ({ modulesTypes, pages, pagesSettings, modules, user }) => {
  const routes = getRoutes(true);
  let links = [];
  modulesTypes.map((moduleType) => {
    if (moduleType === ModuleService.TYPE_PAGE) {
      const pagesLinks = pages ?
        pages.map(page => ({ path: `/${page}`, name: pagesSettings[page].title })) : [];
      links = [...links, ...pagesLinks];
    }
    if (customLinksModules.indexOf(moduleType) !== -1) {
      links.push({ moduleType });
    }
    const route = routes[moduleType];
    if (route && route.component && !route.child) {

      if(route.module == ModuleService.TYPE_STRIPE_INVOICES && (!user || (user && !user.stripe_id ))) {
        return moduleType;
      }
      links.push({
        path: route.path,
        name: route.moduleTitle && modules[route.module] ? modules[route.module].title : route.name,
      });
    }
    return moduleType;
  });
  return links;
};

const defaultCompanyName = 'Yarea portal';
const createTitle = ({ company = defaultCompanyName, slogan }) => slogan ? `${company} - ${slogan}` : company;

export default { createNavLinks, createTitle };



// WEBPACK FOOTER //
// ./src/helpers/fromSubscriber.helper.js